import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { S02FindALocationProps } from './S02FindALocation.types';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { translationClasses } from 'src/shared/TranslationClasses';
import { CreateFindALocationModel } from './S02FindALocation.service';
import { FindALocation } from '@ahc-digital/component-library';
import { useEffect, useState } from 'react';
import { fetchSpecialityList } from 'src/shared/ReputationLocatorApi.service';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: S02FindALocationProps): JSX.Element => {
  const [options, setOptions] = useState({});
  const context = useCustomSitecoreContext();
  const reputationLocationSearchID = context?.reputationLocationSearchID?.value;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  useEffect(() => {
    async function fetchOptions() {
      try {
        const response = reputationLocationSearchID
          ? await fetchSpecialityList(
              reputationLocationSearchID,
              props?.fields?.FilterType?.value ?? ''
            )
          : {};
        setOptions(response);
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    }
    fetchOptions();
  }, [reputationLocationSearchID, props?.fields?.FilterType?.value]);

  const locationSearchURL: string = context?.locationSearchURL?.value ?? '';
  const googleMapEnvName = context?.envVariableNameForGoogleMapAPI?.value;

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  return (
    <FindALocation
      {...CreateFindALocationModel(props, locationSearchURL, googleMapEnvName || '', options)}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};
